import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { EviVanLanschotMaskedBanner } from "./EviVanLanschotMaskedBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const IMAGE_MAP: Record<string, string> = {
  advice:
    "https://www.evivanlanschot.nl/media/zgoexgvb/chef-en-collega-in-restaurantkeuken-2-16-9.jpg?width=2304&height=1120&v=1dc9b4933ee10b0",
  documentsOutgoing:
    "https://www.evivanlanschot.nl/media/espjhk4l/pexels-karolina-grabowska-8527898.jpg?width=660&height=350&quality=80&v=1dc3eba83c46e40",
  documentsIncoming:
    "https://www.evivanlanschot.nl/media/espjhk4l/pexels-karolina-grabowska-8527898.jpg?width=660&height=350&quality=80&v=1dc3eba83c46e40",
  interestRates:
    "https://www.evivanlanschot.nl/media/z14d3aiu/pexels-mikhail-nilov-8297480.jpg?width=1065&height=600&quality=100&v=1dca0c5d67203b0",
  maximumMortgage:
    "https://www.evivanlanschot.nl/media/fpvfsfyy/jakub-zerdzicki-lnnmsumlwo4-unsplash.jpg?width=1065&height=600&quality=100&v=1db8c47a56296b0",
  orientation:
    "https://www.evivanlanschot.nl/media/cajjvcep/tyler-franta-iusj25iyu1c-unsplash.jpg?width=1065&height=600&quality=100&v=1db8c47a58bc990",
};

export const EviVanLanschotPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();

  return (
    <EviVanLanschotMaskedBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={IMAGE_MAP[scope] ?? ""}
    />
  );
};
